import React from "react";
import ScheduleItem from "./ScheduleItem.js";
import Style from "../../styles/js/Styles";

export default function Schedule({ days, handleSchedule }) {
  const style = Style();

  const getValues = (index) => {
    let valuesDay = [];
    days.forEach((item, i) => {
      if (item.day === index) valuesDay.push(item);
    });
    return valuesDay;
  };

  return (
    <div className={style.schedule}>
      <ScheduleItem
        day={getValues(0)}
        handleSchedule={handleSchedule}
        title="Horario Domingo"
      />
      <ScheduleItem
        day={getValues(1)}
        handleSchedule={handleSchedule}
        title="Horario Lunes"
      />
      <ScheduleItem
        day={getValues(2)}
        handleSchedule={handleSchedule}
        title="Horario Martes"
      />
      <ScheduleItem
        day={getValues(3)}
        handleSchedule={handleSchedule}
        title="Horario Miércoles"
      />
      <ScheduleItem
        day={getValues(4)}
        handleSchedule={handleSchedule}
        title="Horario Jueves"
      />
      <ScheduleItem
        day={getValues(5)}
        handleSchedule={handleSchedule}
        title="Horario Viernes"
      />
      <ScheduleItem
        day={getValues(6)}
        handleSchedule={handleSchedule}
        title="Horario Sábado"
      />
    </div>
  );
}
